/**
 * StreamingIndicator Component
 * Shows animated bouncing dots during streaming
 */

import React from 'react';

export const StreamingIndicator: React.FC = () => {
  return (
    <span className="inline-flex gap-1 ml-1">
      <span className="w-2 h-2 bg-gray-600 dark:bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
      <span className="w-2 h-2 bg-gray-600 dark:bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
      <span className="w-2 h-2 bg-gray-600 dark:bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
    </span>
  );
};
